import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonTitle,
  IonToolbar,
  ModalController,
  ToastController,
} from '@ionic/angular/standalone';
import { catchError, EMPTY } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
  EMAIL_VALIDATION_ERRORS,
  PASSWORD_VALIDATION_ERRORS,
  PSEUDO_VALIDATION_ERRORS,
} from '../../../constants/validation-errors';
import { AuthenticationService } from '../../../services/authentication.service';
import { ValidationErrorsComponent } from '../../validation-errors/validation-errors.component';

@Component({
  selector: 'cmn-signup',
  templateUrl: './signup-page.component.html',
  styleUrls: ['./signup-page.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonContent,
    IonItem,
    IonInput,
  ],
})
export class SignupPageComponent {
  public signupError: string | undefined;
  public signupForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    pseudo: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(15),
    ]),
    password: new UntypedFormControl('', [Validators.required]),
  });
  public readonly emailValidationErrors = EMAIL_VALIDATION_ERRORS;
  public readonly pseudoValidationErrors = PSEUDO_VALIDATION_ERRORS;
  public readonly passwordValidationErrors = PASSWORD_VALIDATION_ERRORS;
  private readonly toastController = inject(ToastController);
  private readonly modalController = inject(ModalController);
  private readonly authenticationV2Service = inject(AuthenticationService);
  private readonly destroyRef = inject(DestroyRef);

  signup(): void {
    const { email, password, pseudo } = this.signupForm.value;
    this.authenticationV2Service
      .register(pseudo, email, password)
      .pipe(
        tap(() => {
          this.modalController.dismiss();
          this.successSignupToast();
        }),
        catchError((error: Error) => {
          this.signupError = error.message;
          return EMPTY;
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  async successSignupToast(): Promise<void> {
    const toast = await this.toastController.create({
      message: '✅ Connecté',
      duration: 1500,
      position: 'top',
      translucent: true,
    });
    await toast.present();
  }

  dismiss(): void {
    this.modalController.dismiss();
  }
}
